import * as React from 'react';

type Props = {
  className?: string;
};

const CheckmarkIconRed: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    overflow="visible"
    width="64px"
    height="64px"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(10.000000, 15.000000)" fill="#ef2e24">
        <path d="M42.11719,1.64843 C40.9453167,0.476556667 39.77344,0.54166 38.60156,1.84374 C31.30989,10.30728 22.19531,20.88671 16.72656,27.23437 C13.79687,24.64648 7.9375,19.4707 5.00781,16.88281 C3.83593667,15.7109367 2.72916667,15.77604 1.6875,17.07812 C0.515626667,18.2499933 0.58073,19.4218667 1.88281,20.59374 C6.375,24.6302 11.99024,29.67578 15.35938,32.70312 C15.8802067,33.0937467 16.4661433,33.28906 17.11719,33.28906 C17.18229,33.28906 17.26367,33.28906 17.3125,33.28906 C18.22396,33.02864 18.8098967,32.70312 19.07031,32.3125 C26.81771,23.26302 36.50195,11.95117 42.3125,5.16406 C43.4843733,3.86197333 43.41927,2.69009667 42.11719,1.64843 Z" />
      </g>
    </g>
  </svg>
);

export default CheckmarkIconRed;
